const lang = {
  challenge: {
    detail: {
      chall_detail_parti: "Teilnehmer",
      chall_detail_reward: "Belohnungen",
      chall_detail_reward_item: "Elemente",
      chall_detail_reward_badges: "Abzeichen",
      chall_detail_reward_badge: "Abzeichen",
      chall_detail_reward_point: "Punkte",
      chall_detail_goal: "Ziel",
      chall_detail_dist: "Distanz",
      chall_detail_workout: "Training",
      chall_detail_workout_detail: "Berechtigte Workouts",
      chall_detail_intro: "Einführung",
      chall_detail_rank: "Bestenliste",
      chall_detail_btn_join: "Beitreten",
      chall_detail_time: "Endet in",
      chall_detail_time_days: "Tage",
      chall_detail_status_my: "Mein Status",
      chall_detail_status_team: "Teamstatus",
      chall_detail_status_rank: "Rangliste",
      chall_detail_status_progress: "Fortschritt",
      chall_detail_status_duration: "Dauer",
      chall_detail_status_dist: "Distanz",
      chall_detail_status_cal: "Kalorien",
      common_steps_low: "Schritte",
      common_rep_count: "Wiederholungen",
      chall_detail_status_day: "Trainingstage",
      chall_detail_status_best: "Bestes Ergebnis",
      chall_detail_status_contribution: "Mein Beitrag",
      chall_detail_btn_try: "Erneut versuchen",
      chall_detail_btn_start: "Herausforderung starten",
      chall_detail_btn_continue: "Herausforderung fortsetzen",
      chall_detail_btn_expired: "Herausforderung abgelaufen",
      chall_detail_reward_item_claim: "Einlösen",
      chall_detail_reward_badge_display: "Anzeige",
      chall_detail_toast_unstart: "Herausforderung nicht gestartet",
      chall_detail_toast_end: "Herausforderung beendet",
      chall_detail_rank_empty:
        "Keine Ranglisten-Daten, starte deine Herausforderung und aktualisiere die Bestenliste.",
      chall_detail_workout_collection_mt: "Spezifische Sammlung",
      chall_detail_workout_route: "Routeninfo",
      chall_detail_reward_mt: "Alle Belohnungen",
      chall_detail_workout_outrun: "Laufen im Freien",
      chall_detail_workout_outcycle: "Radfahren im Freien",
      chall_detail_workout_outwalk: "Outdoor-Spaziergang",
      chall_detail_workout_yoga: "Yogakurs",
      chall_detail_workout_cardio: "Kardiokurs",
      chall_detail_workout_strength: "Kraftkurs",
      chall_detail_workout_stretch: "Dehnkurs",
      chall_detail_workout_run: "Laufband",
      chall_detail_workout_cycle: "Radfahren",
      chall_detail_workout_row: "Rudergerät",
      chall_detail_workout_ellipt: "Ellipsentrainer",
      chall_detail_workout_step: "Stepper",
      chall_detail_workout_rnr: "Ruder-N-Ride",
      chall_detail_workout_minibike: "Mini-Bike",
      chall_detail_workout_ski: "Skifahrer",
      chall_detail_workout_jump: "Seilspringen",
      chall_detail_workout_vibration_treadmill: "Vibrationslaufband",
      chall_detail_product_recommend: "Produktempfehlung",
      chall_detail_version_update_note: "Diese Version unterstützt diese Funktion nicht. Bitte aktualisieren.",
      chall_detail_workout_stair: 'Treppensteiger',
      chall_detail_workout_slider: 'Slider Climber',

      chall_detail_workout_runcour: "Laufkurse",
      chall_detail_workout_cyclecour: "Fahrradkurse",
      chall_detail_workout_elliptcour: "Ellipsentrainer-Kurse",
      chall_detail_workout_rowcour: "Ruderkurse",
      chall_detail_workout_stepcour: "Stepper-Kurse",
      chall_detail_workout_prenatal: "Schwangerschaftskurse",
      chall_detail_workout_postpartum: "Kurse nach der Geburt",
      chall_detail_workout_meditation: "Meditationskurse",
      chall_detail_workout_rnrcourses: "Row-N-Ride Kurse",
      chall_detail_workout_audio: "Audiokurse",
      chall_detail_workout_pilates: "Pilates",
      chall_detail_workout_climber: "Kletterkurs",


      chall_detail_workout_all: "Alle Workouts von der Sunnyfit-App erfasst.",
      chall_detail_workout_collection:
        "Trainiere mit Kursen aus dieser Sammlung",
      chall_detail_goal_intro:
        "Trainiere %s Tage, %s %s täglich.",
      chall_detail_team_join_mt: "Einem Team beitreten",
      chall_detail_team_create: "Team erstellen",
      chall_detail_team_join_conf: "Team beitreten",
      chall_detail_team_create_cxl: "Abbrechen",
      chall_detail_team_create_conf: "Speichern",
      chall_detail_team_user_follow: "Folgen",
      chall_detail_team_user_assign: "Als Kapitän festlegen",
      chall_detail_team_user_remove: "Aus Team entfernen",
      chall_detail_team_leave: "Team verlassen",
      chall_detail_team_user_following: "Folgen",
      chall_detail_team_leave_note: "Möchten Sie dieses Team wirklich verlassen?",
      chall_detail_team_leave_cxl: "Abbrechen",
      chall_detail_team_leave_conf: "Bestätigen",
      chall_detail_team_me: "Ich",
      chall_detail_team_leave_toast:
        "Bitte weise einem deiner Teammitglieder die Kapitänsrolle zu.",
      chall_detail_team_join_toast: "Bitte wähle ein Team",
      chall_detail_team_join_toast_full:
        "Das gewählte Team ist voll. Bitte wähle ein anderes Team oder erstelle ein neues Team.",
      chall_detail_team_create_toast: "Bitte geben Sie Ihren Teamnamen ein.",
      chall_detail_result_descrip_goal_com_1: "Glückwunsch!",
      chall_detail_result_descrip_goal_com_single: `Deine harte Arbeit hat sich ausgezahlt. Lass uns das Tempo beibehalten!`,
      chall_detail_result_descrip_goal_com_team: `Die harte Arbeit deines Teams hat sich ausgezahlt. Lass uns den Schwung beibehalten!`,
      chall_detail_result_descrip_goal_incom_1: "Weiter so! 💪",
      chall_detail_result_descrip_goal_incom_2: `Atme durch, setze zurück, und lass uns den nächsten gemeinsam angehen!`,
      chall_detail_result_descrip_other1_1: `Wow, du bist ganz oben!`,
      chall_detail_result_descrip_other1_single:
        "Dein Einsatz hat sich ausgezahlt. Bleib führend und inspiriere andere!",
      chall_detail_result_descrip_other1_team: `Das Engagement deines Teams hat sich ausgezahlt. Führe weiter und inspiriere andere!`,
      chall_detail_result_descrip_other2_1: "Gute Arbeit! 💪",
      chall_detail_result_descrip_other2_single: `Du bist auf Platz %s! Weiter so!`,
      chall_detail_result_descrip_other2_team: `Your team is {rank} place! Way to go!`,
      chall_detail_result_descrip_other3_single: "Du bist auf Platz %s!",
      chall_detail_result_descrip_other3_team: "Dein Team ist auf Platz %s!",
      chall_detail_result_descrip_other3_2: `Weiter so, und lass uns beim nächsten Mal eine noch höhere Platzierung anstreben!`,
      chall_detail_result_reward: `Belohnungen erhalten`,
      chall_detail_result_done: `Fertig`,
      chall_detail_result_share: `Teilen`,
      chall_detail_result_reward_badge: `Abzeichen`,
      chall_detail_result_reward_point: `Punkte`,
      chall_detail_result_reward_item: `Elemente`,
      chall_detail_workout_collection_time: "Geschätzte Zeit",
      chall_detail_start_workout: "Training starten",
      badge_detail_display: `Im Profil anzeigen`,
      badge_detail_remove: `Vom Profil entfernen`,
      badge_detail_display_toast: `Jetzt in Ihrem Profil angezeigt`,
      badge_detail_remove_toast: `Vom Profil entfernt`,
      invite_from: `Einladen von:`,
      invite_from_friend: `Freunde`,
      invite_from_contact: `Kontakte`,
      invite_from_more: `Mehr`,
      address_edit_mt: "Lieferadresse",
      address_edit_note: "Alle Daten werden verschlüsselt",
      address_edit_country: "Land / Region",
      address_edit_name: "Name",
      address_edit_street: "Straßenadresse",
      address_edit_apt: "Wohnung/Suite/Andere(Optional)",
      address_edit_city: "Stadt",
      address_edit_state: "Status",
      address_edit_code: "PLZ",
      address_edit_phone: "Telefonnummer",
      address_edit_btn: "Absenden",
      address_edit_state_select_mt: "Bundesland auswählen",
      address_edit_check: "Adresse prüfen",
      address_edit_check_note:
        "Bitte Adresse überprüfen, um korrekte Lieferung sicherzustellen. Verlorene Preise werden nicht ersetzt.",
      address_edit_check_cxl: "Abbrechen",
      address_info_mt: "Lieferadresse",
      address_info_name: "Name",
      address_info_phone: "Telefon",
      address_info_address: "Adresse",
      common_courses_count: "Kurse",
      challenge_exchange_title1: 'Möchten Sie Zeit verbringen',
      challenge_exchange_title2: '%s Punkte zum Mitmachen?',
      challenge_exchange_mypt: 'Meine Punkte: %s',
      challenge_exchange_button1: '%s Punkte Beitreten',
      challenge_exchange_button2: 'Verdiene mehr Punkte',
      challenge_exchange_button3: 'Abbrechen',
      challenge_exchange_toast: 'Erfolgreich beigetreten',

      chall_detail_workout_select_route: 'Route wählen',
      chall_detail_workout_route_select: 'Diese Route wählen',
      chall_detail_workout_change_route: 'Change',
      chall_detail_workout_my_route: 'Meine Route',
      chall_detail_status_scoring_rules: 'Punkteregeln',

      chall_scoring_rules_main_title: "Punkte-Aufschlüsselung 🏆",
      chall_scoring_rules_goal_title: "🏁 Abgeschlossen (s% pts)",
      chall_scoring_rules_goal_descrip: "Erreiche die Zielstrecke, um dir deine Punkte für den Abschluss zu sichern.\nStatus: Sofort nach Erreichen der Strecke verdient.",
      chall_scoring_rules_speed_title: "⚡ Geschwindigkeit (max s% pts)",
      chall_scoring_rules_speed_descrip: "Je schneller du ins Ziel kommst, desto höher ist deine Punktzahl! Dein Geschwindigkeitsbonus wird genau in dem Moment berechnet, in dem du die Zielstrecke erreichst.\nTipp: Kürzere Endzeit = Höherer Rang.",
      chall_scoring_rules_bonus_title: "🎯 Wiederholungs-Bonus (max s% pts)",
      chall_scoring_rules_bonus_descrip: "Konstanz zahlt sich aus! Verdiene +1 Extrapunkt jedes Mal, wenn du diese Herausforderung wiederholst (bis zu s% Punkte).",
      chall_scoring_rules_ranking_title: "🥇 Ranglistenregeln",
      chall_scoring_rules_ranking_descrip: "Gesamtpunktzahl: Deine Endpunktzahl = Ziel + Geschwindigkeit + Bonus (maximal 100 Punkte).\nFixierung: Die Punktzahlen werden in dem Moment eingefroren, in dem du das Ziel erreichst. Weitere Bewegung dient nur der Trainingsaufzeichnung und ändert nichts an deinem Rang.\nUnentschieden: Bei Punktgleichheit gewinnt die schnellere Endzeit.",
      
      share_challenge_poster_bub: '🔥 Mach mit bei dieser Herausforderung! 🏆️',
      share_poster_sologn: 'Werde kostenlos fit, wachse mit Sunny Fam👉️',
      share_poster_challenge_success: 'Herausforderung gemeistert',

      common_block_pop_title: "Nutzung begrenzt",
      chall_detail_join_limit_content: 'Aufgrund der Erkennung Ihres ungewöhnlichen Datenverhaltens wurden Ihre Challenge-Funktionen zur Gewährleistung der Fairness der Community eingeschränkt.',
      me_contact: '„Kontakt“',
    },
  },
  workout: {
    collection: {
      detail: {
        workout_course_collection_detail_mt: "Sammlung",
        workout_wt_collection_detail_mt: "Weltreise-Kollektion",
        workout_course_collection_detail_count: "Kurse",
        workout_course_collection_detail_limit: "Kurs für begrenzte Zeit",
      },
    },
  },
  support: {
    equipment: {
      detail: {
        equip_support_equip_main: "Unterstützungsgeräte",
        equip_support_equip_enter_tips: "Bitte geben Sie Ihr Gerätemodell ein:",
        equip_support_equip_enter_content: "Modell eingeben...",
        equip_support_equip_tips_main: "Tipps",
        equip_support_equip_tips_content: "Wenn Sie das Gerätemodell nicht kennen, können Sie das Etikett am Gerät überprüfen, wie im Bild unten gezeigt.",
        equip_support_equip_contact_us_btn: "Kontakt",
        equip_support_equip_view_courses_btn: "Kurse ansehen",
        btn_common_ok: "OK",
        btn_common_search: "Suche",
      },
    },
  },
  contact: {
    detail: {
      contact_us_mt: "Kontaktieren Sie uns",
      contact_us_feedback: "Feedback senden",
      contact_us_note:
        "Senden Sie Ihr Feedback oder Problem und wir melden uns innerhalb von 2 Werktagen bei Ihnen!",
      contact_us_issue_type: "Ich brauche Hilfe bei",
      contact_us_issue_type_input: "Bitte Problem auswählen",
      contact_us_name: "Vollständiger Name",
      contact_us_name_input: "Geben Sie hier Ihren vollständigen Namen ein",
      contact_us_equip: "Gerätemodell (Optional)",
      contact_us_equip_input: "Gerätemodell-Nr. eingeben",
      contact_us_email: "E-Mail",
      contact_us_email_input: "Gib hier deine E-Mail ein",
      contact_us_describe: "Problem beschreiben",
      contact_us_describe_input: "Hinterlasse hier deine Nachricht",
      contact_us_image: "Bild/Video-Anhang",
      contact_us_contact_info: "Kontaktinformationen",
      btn_common_send: "Senden",
      btn_common_submit: "Absenden",
      contact_us_issue_type_mt: "Problemtyp",
      contact_us_issue_type_equip: "Geräteprobleme",
      contact_us_issue_type_equip_note: "Messproblem/Beschädigt/Fehlende Teile",
      contact_us_issue_type_app: "App-Probleme",
      contact_us_issue_type_app_note: "Funktionen/Benutzererlebnis",
      contact_us_issue_type_suggest: "Vorschläge",
      contact_us_issue_type_suggest_note: "Kurse hinzufügen / Funktionen hinzufügen",
      contact_us_issue_type_equip_meter: "Zählerproblem",
      contact_us_issue_type_equip_damage: "Beschädigte/Fehlende Teile",
      contact_us_issue_type_app_regist: "Registrierung/Anmelden",
      contact_us_issue_type_app_connect: "Bluetooth-Verbindung",
      contact_us_issue_type_app_googlefit: "Google Fit",
      contact_us_issue_type_app_applehealth: "Apple Health",
      contact_us_issue_type_app_video: "Video-/Audiowiedergabe",
      contact_us_issue_type_app_plan: "Pläne und geplante Kurse/Programme",
      contact_us_issue_type_app_account: "Konto und Profil",
      contact_us_issue_type_app_update: "Versionsaktualisierung",
      contact_us_issue_type_app_data: "Datenanomalien",
      contact_us_issue_type_app_other: "Andere App-Probleme",
      contact_us_issue_type_app_wifi: "WLAN-Verbindung",
      contact_us_result_mt: "Danke für dein Feedback!",
      contact_us_result_st: "Wir melden uns innerhalb von 2 Werktagen.",
      btn_common_done: "Fertig",
      btn_common_next: "Weiter",

      btn_common_camera: "Kamera",
      btn_common_photo_album: "Foto aus Album wählen",
      btn_common_video_album: "Video aus Album wählen",
      btn_common_cancel: "Abbrechen",

      camera_note_main: "Kamerazugriff",
      camera_note_content: "Wir benötigen Zugriff auf Ihre Kamera, um Inhalte hochzuladen.",
      photo_note_main: "Fotoerlaubnis",
      photo_note_content:
        "Wir benötigen Zugriff auf Ihre Fotos, um Inhalte hochzuladen.",

      photo_note_btn_open_settings: "Einstellungen öffnen",
      uploading_note_main: "Feedback wird hochgeladen..",
      uploading_note_schedule: "{currentUploadIndex} von {totalUploadCount} Dateien hochgeladen",
      uploading_note_tips: "Videodatei kann länger dauern",

      album_attach_upload_failed_toast: "Upload fehlgeschlagen. Erneut versuchen.",
      album_attach_image_toast: "Sie können bis zu {number} Bilder anhängen",
      album_attach_image_length_toast: "Sie können Bilder mit jeweils bis zu {size} MB auswählen",
      album_attach_video_toast: "Sie können bis zu {number} Video anhängen",
      album_attach_video_length_toast1: "Veuillez sélectionner une vidéo dans les {number} secondes",
      album_attach_video_size_toast: "Bitte wählen Sie ein Video innerhalb von {number} MB aus.",
    },
  },
  workoverview: {
    detail: {
      common_steps: "Schritte",
      common_steps_low: "Schritte",
      workout_result_mt: "Trainingsdaten",
      workout_result_cal_in: "Verbrannte Kalorien",
      workout_result_hamburger: "Hamburger",
      workout_result_hamburger_note:
        "Ein Hamburger entspricht ungefähr %s Kalorien",
      workout_result_data_time: "Zeit",
      workout_result_data_dis: "Distanz",
      workout_result_data_cal: "Kalorien",
      workout_result_data_height: "Höhe",
      workout_result_data_floors: "Etagen",
      workout_result_data_cal_note:
        "Die in der App angezeigten verbrannten Kalorien basieren auf Ihrer Größe und Ihrem Gewicht, daher können sie von den Daten Ihres Geräts abweichen.",
      workout_result_data_floor_note: "Eine Etage sind etwa 2,5 Meter.",
      workout_result_data_steps: "Schritte",
      workout_result_data_stroke: "Züge",
      workout_result_data_stride: "Schrittezähler",
      workout_result_data_avg: "Ø",
      workout_result_data_max: "Max",
      workout_result_data_hr: "HF",
      workout_result_data_hr_analysis: "Herzfrequenzanalyse",
      workout_result_data_hr_zone: "Zone %s",
      workout_result_data_speed: "Geschwindigkeit",
      workout_result_data_pace: "Tempo",
      workout_result_pace_fast: "Schnellste",
      workout_result_data_resist: "Widerstand",
      workout_result_data_cadence: "RPM",
      workout_result_data_spm: "SPM",
      workout_result_data_str: "Schlagfrequenz",
      workout_result_data_rep: "Wiederholungen",
      workout_result_data_reps: "Wiederholungen",
      workout_result_evaluate: "Bewerten",
      workout_result_post: "Ergebnis posten",
      workout_result_share_video: "Tolles Video teilen",
      workout_result_wu: "Aufwärmen",
      workout_result_main: "Haupttraining",
      workout_result_cd: "Abkühlen",
      workout_result_treadmill: "Laufbandtraining",
      workout_result_bike: "Indoor-Radtour",
      workout_result_elliptical: "Ellipsentraining",
      workout_result_rnr: "Row-N-Ride",
      workout_result_rower: "Rudertraining",
      workout_result_stepper: "Stepper-Training",
      workout_result_data_incline: "Steigung",
      workout_result_run: "Laufen im Freien",
      workout_result_walk: "Outdoor-Spaziergang",
      workout_result_cycling: "Outdoor Cycling",
      workout_result_result_workout: "Workouts",
      workout_result_chall_score: "Punkte",
      workout_result_map_hide_note: "Karte wird ausgeblendet, wenn Sie teilen.",
      workout_result_on_equipment: "An Geräten",
      workout_result_off_equipment: "Ohne Geräte",
      btn_common_done: "Fertig",
      btn_common_share: "Teilen",
      btn_common_try_again: "Erneut versuchen",
      common_completed: "Abgeschlossen",
      common_remaining: "Verbleibend",
      share_common_open: "Öffnen",
      social_user_follow: "Folgen",
      social_user_following: "Folgen",
      share_common_join_us: "Mach mit",
      workout_result_movement_tag: "Bewegung",
      workout_result_movement_note: "Dieses Bewegungstraining wurde aus dem Al-Plan angepasst. Möchtest du deinen exklusiven Plan erstellen?",
      btn_try_now: "Jetzt ausprobieren",
      workout_result_share: 'Share My Result',
      workout_result_movement_feedback: "Feedback",
      workout_result_movement_feedback_mt: "Feedback hilft uns, besser zu werden",
      workout_result_movement_feedback_tip: "Wie fühlst du dich bei diesem Training?",
      workout_result_rpe_ask: "Wie hat sich diese Einheit angefühlt?",
      workout_result_rpe_easy: "Leicht",
      workout_result_rpe_challenge: "Hart",
      workout_result_rpe_level1: "Mühelos",
      workout_result_rpe_level2: "Sehr leicht",
      workout_result_rpe_level3: "Angenehm",
      workout_result_rpe_level4: "Ich komme ins Schwitzen",
      workout_result_rpe_level5: "Etwas außer Atem",
      workout_result_rpe_level6: "Es wird anstrengend",
      workout_result_rpe_level7: "Sprechen fällt schwer",
      workout_result_rpe_level8: "Schweres Atmen",
      workout_result_rpe_level9: "Fast am Limit",
      workout_result_rpe_level10: "Nichts mehr übrig",
      workout_result_rpe_submit: "Senden",
      workout_result_rpe_submit_fail:
        "Senden fehlgeschlagen. Erneut versuchen.",
      workout_result_rpe_loading_line1: "RPE: {n}/10. Verstanden!",
      workout_result_rpe_loading_line2:
        "Ich prüfe dein Training...",
      workout_result_coach_insight: "Coach-Einblick",
      workout_result_ai_rpe_caption: "RPE : {n} / 10",
      workout_result_rpe_note:
        "RPE steht für wahrgenommene Anstrengung. Es zeigt, wie anstrengend sich dein Training auf einer Skala von 1 bis 10 angefühlt hat.",
      workout_result_ask_coach: "Coach fragen",
      btn_common_submit: "Absenden",
    },
  },
  midYearReport: {
    workoutData_burnCalories: "Total Calories Burned",
    workoutData_workoutTimes: "Total # of Workouts",
    workoutData_workoutDays: "Total Days With Workouts",
    workoutData_workoutDuration: "Total Workout Time",

    community_title: `Thank you for contributing to 
    and being part of the SunnyFit community!`,
    community_friendsRanking: "Ranking Among Friends",
    community_rankOpen: "Top ",
    community_rankEnd: " among friends",
    community_postShares: "Posts Shared",
    community_likesReceived: "Posts Liked",
    community_share_unit: "Posts",
    community_like_unit: "Likes",


    // favoriteWorkout_title: "Favorite Workout Type",
    favoriteWorkout_totalNumberOfWorkouts: " Workouts Completed",
    favoriteWorkout_equivalentToSeveralBurgers: "Calories Burned Equal To",
    favoriteWorkout_totalDistance_Metric: "Total distance in kilometers", //公制距离
    favoriteWorkout_totalDistance_Imperial: "Total distance in miles", //英制距离
    favoriteWorkout_MaxRPMAchieved: "Max RPM Achieved",
    favoriteWorkout_MaxSPMAchieved: "Max SPM Achieved",
    favoriteWorkout_TotalDuration: "Total duration",
    favoriteWorkout_TotalCaloriesBurned: "Calories Burned",
    favoriteWorkout_fastestPace: "Your fastest pace completed",
    favoriteWorkout_fastestCadence: "Your fastest cadence completed",
    // favoriteWorkout_fastReps: "Your fastest reps completed",
    // favoriteWorkout_fastStrokesRate: "Your fastest strokes rate completed",
    favoriteWorkout_maxStrokes: "Your max strokes completed",
    favoriteWorkout_maxFrequency: "Your max frequency completed",
    favoriteWorkout_totalDaysOfWorkout: "Total Days of &*& Workouts",

    favorite_favorite: "Favorite",
    favoriteTrainer_descTime: "Over the past six months, you took workout courses with &*& Sunny Trainers",
    favoriteTrainer_descTrain: "You completed &*& courses with your favorite trainer, &*& !",
    
    // favoriteCourses_accompanyYou: "accompany you",
    favoriteCourses_title: "New courses are added to SunnyFit every week!",
    favoriteCourses_coursesDesc: "That's equivalent to watching &*& movies!",

    noData_title: "SunnyFit Workout Report",
    noData_info: "Unfortunately, the workout data you provided for 2024 is insufficient. ",

    common_share: "Share",
    common_back: "Back",
    common_joinNow: "Join Now",
    common_update: "Please update to the latest version.",
  },
  pointsMall:{
    product:{
      detail: {
        "product_detail_top_title":"Produktdetails",
        "product_detail_mypoints":"Meine Punkte:",
        "product_detail_exchange":"Tauschen",
        "product_detail_earn":"Verdiene mehr Punkte",
        "product_detail_stock":"Nicht verfügbar",
        "product_detail_null_title":"Die Daten sind ungewöhnlich, bitte versuchen Sie es später erneut.",
        "product_detail_null_button":"Aktualisieren",
        "product_detail_promotional1": "Begrenzt endet %s",
        "product_detail_promotional2": "Begrenzt | Nur noch %s übrig",
        "product_detail_promotional3": "Begrenzt | Ausverkauft",
        "product_detail_gift_others": "Gift for Others",
        "product_detail_gift_myself": "Gift for Myself"
      }
    },
    order:{
      detail: {
        "exchange_detail_my_order_title":"Meine Bestellung",
        "exchange_detail_view_points":"Meine Punkte",
        "exchange_detail_discount": "Rabatt",
        "exchange_detail_expected_deduction":"Erwarteter Abzug",
        "exchange_detail_balance":"Balance",
        "exchange_detail_out_of_stock":"Dieser Artikel ist derzeit nicht verfügbar. Bitte bald wieder nachsehen.",
        "exchange_detail_redemption_toast":"Die Einlösung überschreitet das Limit.",
        "exchange_detail_confirm_exchange":"Austausch bestätigen",

        "exchange_successful_title":"Einlösung erfolgreich",
        "exchange_successful_goods_send_info":"Die Ware wird innerhalb von 3-5 Werktagen versandt!",
        "exchange_successful_check_order_detail":"Um den Einlösungsprozess zu starten, überprüfen Sie bitte Ihre Bestelldetails.",
        "exchange_successful_back":"Zurück",
        "exchange_successful_view":"Bestelldetails anzeigen",

        "orders_history_detail_address_title1":"Telefon",
        "orders_history_detail_address_title2":"Adresse",
        "orders_history_detail_address_title3":"E-Mail",
        "orders_history_null_title": "Hier ist es leer",
        "address_detail_add_shipping_address":"Versandadresse hinzufügen",
        "address_detail_add":"Hinzufügen",
        "address_detail_default":"Standard",
        "address_detail_set_as_default":"Als Standard festlegen",
        "address_detail_my_address":"Meine Adresse",
        "address_detail_delete":"Löschen",
        "address_detail_edit":"Bearbeiten",
        "address_detail_add_a_shipping_address":"+ Lieferadresse hinzufügen",
        "address_detail_delete_tips":"Tipps löschen",
        "address_detail_toast":"Möchten Sie diese Adresse wirklich löschen?",
        "address_detail_cancel":"Abbrechen",
        "address_detail_delete":"Löschen",

        "shipping_address_title":"Lieferadresse",
        "shipping_address_data_encryption_info":"Alle Daten werden verschlüsselt",
        "shipping_address_country_region":"Land / Region",
        "shipping_address_first_name":"Vorname",
        "shipping_address_first_name_prompt":"Bitte Vornamen eingeben",
        "shipping_address_last_name":"Nachname",
        "shipping_address_last_name_prompt":"Bitte Nachnamen eingeben",
        "shipping_address_address_line_1":"Adresszeile 1",
        "shipping_address_address_line_1_desc":"Straßenname und Hausnummer, Firmenname",
        "shipping_address_address_line_2":"(Optional) Adresszeile 2",
        "shipping_address_address_line_2_sub":"(Optional) ",
        "shipping_address_address_line_2_desc":"Gebäude/Wohnung/Suite-Nr., Einheit, Etage, etc.",
        "shipping_address_state":"Status",
        "shipping_address_state_prompt":"Bitte Bundesland auswählen",
        "shipping_address_city":"Stadt",
        "shipping_address_city_prompt":"Bitte Stadt eingeben",
        "shipping_address_zip_code":"PLZ",
        "shipping_address_zip_code_prompt":"Bitte PLZ",
        "shipping_address_phone_number":"Telefonnummer",
        "shipping_address_phone_number_prompt":"Bitte Telefonnummer",
        "shipping_address_email_address":"E-Mail-Adresse",
        "shipping_address_email_address_desc":"Zum Erhalt von Versandinformationen",
        "shipping_address_security_privacy_info":"Sicherheit & Datenschutz",
        "shipping_address_security_privacy_desc":"Wir setzen branchenübliche physische, technische und administrative Maßnahmen ein, um Ihre persönlichen Daten zu schützen.",
        "shipping_address_save":"Speichern",
        "shipping_address_name":"Bitte geben Sie Ihren Vor- und Nachnamen mit 2-32 Zeichen ein.",
        "shipping_address_toast":"Entschuldigung, unser Punkte-Einlösungsprogramm ist derzeit nur für Nutzer in den 48 zusammenhängenden Vereinigten Staaten verfügbar.",

      "orders_history_top_title":"Bestellverlauf",
      "orders_history_list_view":"Details anzeigen",
      "orders_history_list_date":"Austauschdatum:",
      "orders_history_null_button":"Punkte tauschen",
      "orders_history_detail_top_title":"Bestelldetails",
      "orders_history_detail_tracking_title":"Sendungsnummer",
      "orders_history_detail_coupon_code":"Gutscheincode",
      "orders_history_detail_coupon_time":"Ablaufzeit des Coupons",
      "orders_history_detail_tracking_state":"Verarbeitung",
      "ordershi_history_detail_date_title":"Tausche Datum",
      "orders_history_detail_spend_title":"Verbringen",
      "orders_history_detail_order_title":"Bestellnummer",
      "orders_history_detail_instructions":"Anweisungen",
      "orders_history_detail_copy":"Kopieren",
      "orders_history_detail_copy_toast":"Kopieren erfolgreich",
      "orders_history_tab_1":"Bestellungen tauschen",
      "orders_history_tab_2":"Kursbestellungen",

      "invite_reward_order_type":"Empfehlungsprämie",
      "event_reward_order_type":"Eventpreis",

      "rewards_points_toast_error200": "Bestellung erfolgreich erstellt",
      "rewards_points_toast_error302": "Aktion ungültig",
      "rewards_points_toast_error404": "Die Daten sind ungewöhnlich, bitte später erneut versuchen.",
      "rewards_points_toast_error412": "Die Daten sind ungewöhnlich, bitte versuchen Sie es später erneut.",
      "rewards_points_toast_error999": "Die Daten sind ungewöhnlich, bitte später erneut versuchen.",
      "rewards_points_toast_error14001": "Artikel eingestellt",
      "rewards_points_toast_error14002": "Dieser Artikel ist derzeit nicht verfügbar.Bitte bald wieder nachsehen.",
      "rewards_points_toast_error14003": "Unzureichende Punkte",
      "rewards_points_toast_error14004": "Einlösung überschreitet Limit",
      "rewards_points_toast_error14005": "Nicht im Aktionszeitraum",
      "rewards_points_toast_error14006": "Limitierte Promo-Einlösung erschöpft",
      "rewards_points_toast_error14008": "The Gift has been claimed",
      "rewards_points_toast_error14010": "Past the claim validity period - Gift has been returned",
      }
    },
  },
  common: {
    common_no_content: "Kein Inhalt",
    common_loading_failed: "Laden fehlgeschlagen",
    common_refresh: "Refresh",
    common_loading: "Wird geladen...",
    common_points: "Punkte",
    common_intensity_beg: "Anfänger",
    common_intensity_int: "Mittelstufe",
    common_intensity_adv: "Fortgeschritten",
    common_no_more_data: "Keine weiteren Daten",
    common_days: "Tage",
  },
  workoutType: {
    Treadmill: "Treadmill",
    IndoorBike: "Indoor Bike",
    Elliptical: "Elliptical",
    Stepper: "Stepper",
    Rowing: "Rowing",
    RowNRide: "Row-N-Ride",
    Cardio: "Cardio",
    Yoga: "Yoga",
    Strength: "Strength",
    prenatal: "prenatal",
    postpartum: "postpartum",
    meditation: "meditation",
    Audio: "Audio",
    Stretching: "Stretching",
    outdoorRunning: "outdoor running",
    outdoorCycling: "outdoor cycling",
    outdoorWalking: "outdoor walking",
  }
};
export default lang;



// WEBPACK FOOTER //
// ./src/locales/de.js